"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    colors: {
        backgroundError: '#FFF1ED',
        backgroundPrimaryAccent: '#EFF9F8',
        backgroundInactive: '#EDEDED',
        backgroundWarning: '#FFF6D1',
        backgroundInfo: '#EFF4FA',
        borderDefault: '#D1D3D7',
        black: '#000000',
        error: '#EE0606',
        indeterminate: '#B2B7BF',
        warning: '#FFD119',
        white: '#ffffff',
        primaryAccent: '#2EA59A',
        primaryAccentDark: '#178077',
        primaryAccentHover: '#23BEAE',
        primaryAccentLight: '#8FDFCF',
        secondaryAccent: '#2462BC',
        secondaryAccentDark: '#203965',
        textDefault: '#586272',
        textDark: '#252930',
        textInactive: '#8C95A6',
        textInput: '#383D47',
        textLight: '#B2B7BF',
        textLink: '#156CED',
        textNavigation: '#333333',
        iconGrey: '#595959',
        iconLogoAccent: '#1FAB9E',
        svgCreditCard: '#4587E5',
        svgCreditCardNumber: '#6E6E6E',
        svgCreditCardBar: '#455360',
        svgCreditCardRed: '#A40000',
        svgCreditCardSign: '#ADCBEA',
        svgGlobe: '#0C60F0',
    },
    font: {
        family: {
            sans: '"Rubik", sans-serif',
        },
        weight: {
            light: 300,
            normal: 400,
            medium: 500,
            semibold: 600,
        },
        size: {
            xxl: {
                fontSize: '24px',
                lineHeight: '28px',
            },
            xl: {
                fontSize: '20px',
                lineHeight: '24px',
            },
            l: {
                fontSize: '18px',
                lineHeight: '22px',
            },
            m: {
                fontSize: '16px',
                lineHeight: '19px',
            },
            s: {
                fontSize: '14px',
                lineHeight: '16.6px',
            },
            xs: {
                fontSize: '12px',
                lineHeight: '14.2px',
            },
        },
    },
    spacing: {
        none: '0',
        xxs: '4px',
        xs: '8px',
        s: '16px',
        m: '32px',
        l: '64px',
        xl: '128px',
        xxl: '256px',
    },
    pageLayout: {
        minWidth: '767px',
        menuHeight: '57px',
    },
    borderRadius: '8px',
    overlayOpacity: '0.7',
    outline: '2px solid #156CED',
};
